import type { FC } from 'react';

import { CatalogBrowser } from '@entities/Offer';
import type { Offer } from '@psp-aggregator/sdk';

export interface MerchantCatalogProps {
  onSelectionChange: (offers: Offer[]) => void;
  selectedIds: readonly string[];
}

export const MerchantCatalog: FC<MerchantCatalogProps> = (props) => (
  <CatalogBrowser
    onSelectionChange={props.onSelectionChange}
    selectedIds={props.selectedIds}
  />
);

MerchantCatalog.displayName = 'MerchantCatalog';
